import { Link } from "react-router-dom";
import tw from "tailwind-styled-components";

const StyledLink = tw(Link)`
  font-semibold
  tracking-normal	
  ${(props) => props.$headerLink && `my-0 mr-4 r-8`}
`;
export default StyledLink;
